<template>
  <div class="order-wrap" v-if="detail">
    <div class="order-card">
      <div class="card-header" v-if="step==1">{{ ts('AVAILABILITY')['AVAILABILITY'] }}</div>
      <div class="card-header" v-if="step==2">{{ ts('BILLING SUMMARY')['BILLING SUMMARY'] }}</div>
      <template v-if="step==1">
        <div class="card-content">
          <div class="hotel-select" v-if="type != 'select'">
            <template v-if="!productPage.productSaleScope">
              <label>{{ ts('选择酒店')['选择酒店'] }}: </label>
              <el-select v-model="hotelId" :placeholder="ts('请选择提供的酒店')['请选择提供的酒店']">
                <el-option v-for="item in hotelList" :key="item.id" :label="`${item.name}`" :value="item.id"> </el-option>
              </el-select>
            </template>
            <template v-else>
              <label>{{ ts('住宿订单')['住宿订单'] }}: </label>
              <el-select v-model="groupOrderId" :placeholder="ts('请选择附属的住宿订单')['请选择附属的住宿订单']">
                <el-option v-for="item in orderList" :key="item.id" :label="`(${item.checkInDate}-${item.checkOutDate}) ${item.houseResourcesName}`" :value="item.groupOrderId"> </el-option>
              </el-select>
            </template>
          </div>
          <el-row :gutter="30">
            <el-col :span="12">
              <div class="date">
                <el-calendar ref="calendar" v-model="curDate">
                  <template slot="dateCell" slot-scope="{ date, data }">
                    <p :class="detail.inventoryAvailability[findDateIndex(data.day)] ? '' : 'calendar-disabled'">{{ data.day.split('-').slice(2).join('-') }}</p>
                    <!-- <p :class="data.isSelected ? 'is-selected' : ''">{{ data.day.split('-').slice(2).join('-') }}</p> -->
                  </template>
                </el-calendar>
              </div>
            </el-col>
            <el-col :span="12" v-if="productType == '1'">
              <div class="values">
                <div class="quantity">
                  <label>{{ ts('Quantity')['Quantity'] }}</label>
                  <el-input-number v-model="form.quantity" :min="1" :max="10" step-strictly></el-input-number>
                </div>
                <div class="note">
                  <label>{{ ts('Note for supplier')['Note for supplier'] }}:</label>
                  <el-input type="textarea" v-model="form.note"> </el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="12" v-show="productType != '1'">
              <ul class="activity-time">
                <li v-for="time in timeList" :key="time.id" :class="{ active: curTime === time, disabled: !time.availability }">
                  <span @click="time.availability && selectTime(time)">{{ time.name }}</span>
                </li>
              </ul>
            </el-col>
          </el-row>
          <div class="note" v-if="productType != '1'">
            <label>{{ ts('Note for supplier')['Note for supplier'] }}:</label>
            <el-input type="textarea" v-model="form.note"> </el-input>
          </div>
          <ul class="product-meta">
            <li>
              <div class="label">{{ detail.productType_translate }} {{ ts('Name')['Name'] }}:</div>
              <div class="value">{{ detail.name }}</div>
            </li>
            <li>
              <div class="label">{{ ts('Delivery Date and Time')['Delivery Date and Time'] }}</div>
              <div class="value">
                {{ curDateFormat }} <span v-if="curTime && productType != '1'">{{ curTime.name }}</span>
              </div>
            </li>
            <li v-if="productType == '1'">
              <div class="label">{{ detail.productType_translate }} {{ ts('Quantity')['Quantity'] }}</div>
              <div class="value">{{ form.quantity }}</div>
            </li>
            <li v-if="productType != '1' && detail.peopleNum">
              <div class="label">{{ ts('Number of customer')['Number of customer'] }}</div>
              <div class="value">{{ detail.peopleNum }}</div>
            </li>
            <li v-if="curTime">
              <div class="label">{{ detail.productType_translate }} {{ ts('Cost')['Cost'] }}:</div>
              <div class="value">{{ currency }} {{ totalPrice }}</div>
            </li>
            <li v-if="optionalList.length > 0">
              <div class="label">{{ ts('Option Cost')['Option Cost'] }}:</div>
              <div class="value">{{ currency }} {{ optionCost }}</div>
            </li>
            <template v-if="taxes.length > 0">
              <li v-for="tax in taxes" :key="tax.id">
                <div class="label">{{ tax.taxName_translate || tax.taxName }}:</div>
                <div class="value">{{ currency }} {{ tax.price }}</div>
              </li>
            </template>
          </ul>
          <div   class="optional" v-if="extraFeeList.length > 0">
            <div class="optional-selected">
              <b>{{ ts('Optional')['Optional'] }}:</b> <span v-for="o in optionalList" :key="o.id" style="margin-right: 10px">{{ o.name_translate || o.name }} x {{ o.number }}</span>
            </div>
            <div class="optional-choice">
              <div class="child-kid" v-for="option in extraFeeList" :key="option.id">
                <label style="width: calc(100% - 50px);">{{ option.name_translate || option.name }}({{ currency }}{{ option.amount }})</label>
                <el-input-number v-model="option.number" :min="0" :max="10" step-strictly></el-input-number>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer" v-if="type == 'select'">
          <el-button class="btn btn-theme" :loading="btnLoading" @click="confirmOrder" >{{ ts('CONFIRM')['CONFIRM'] }}</el-button>
        </div>
        <div v-else>
          <div class="btn btn-theme" style="display:flex;text-align: center;border-radius: 0;justify-content: center" :loading="btnLoading" @click="next">{{ ts('Next')['Next'] }}</div>
        </div>
      </template>
      <template v-if="step==2">
        <div>
          <div class="card-content">
            <ul class="product-meta">
              <li>
                <div class="label">{{ detail.productType_translate }} {{ ts('Name')['Name'] }}:</div>
                <div class="value">{{ detail.name }}</div>
              </li>
              <li>
                <div class="label">{{ ts('Delivery Date and Time')['Delivery Date and Time'] }}</div>
                <div class="value">
                  {{ curDateFormat }} <span v-if="curTime && productType != '1'">{{ curTime.name }}</span>
                </div>
              </li>
              <li v-if="productType == '1'">
                <div class="label">{{ detail.productType_translate }} {{ ts('Quantity')['Quantity'] }}</div>
                <div class="value">{{ form.quantity }}</div>
              </li>
              <li v-if="productType != '1' && detail.peopleNum">
                <div class="label">{{ ts('Number of customer')['Number of customer'] }}</div>
                <div class="value">{{ detail.peopleNum }}</div>
              </li>
              <li v-if="curTime">
                <div class="label">{{ detail.productType_translate }} {{ ts('Cost')['Cost'] }}:</div>
                <div class="value">{{ currency }} {{ totalPrice }}</div>
              </li>
              <li v-if="optionalList.length > 0">
                <div class="label">{{ ts('Option Cost')['Option Cost'] }}:</div>
                <div class="value">{{ currency }} {{ optionCost }}</div>
              </li>
              <template v-if="taxes.length > 0">
                <li v-for="tax in taxes" :key="tax.id">
                  <div class="label">{{ tax.taxName_translate || tax.taxName }}:</div>
                  <div class="value">{{ currency }} {{ tax.price }}</div>
                </li>
              </template>
            </ul>
            <div class="total-amount" style="border-top: 0px">{{ ts('TOTAL AMOUNT')['TOTAL AMOUNT'] }}: {{ currency }} {{ totalAmount }}</div>

            <div class="table register-form" style="margin-bottom: 24px;" v-if="!registerState.loggedin">
              <div class="table-header">
                <div class="">{{ ts('Member Registration')['Member Registration'] }}</div>
              </div>
              <el-form :model="registerForm" ref="registerForm" label-position="top" label-width="200px"
                       class="user-form">
                <el-row :gutter="80">
                  <el-col :span="12">
                    <el-form-item prop="firstname" :label="ts('First Name:')['First Name:']">
                      <el-tooltip class="box-item" :content="ts('Enter your first name here')['Enter your first name here']" placement="top">
                      <el-input v-model="registerForm.firstName"></el-input>
                      </el-tooltip>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="lastname" :label="ts('Last Name:')['Last Name:']">
                      <el-tooltip class="box-item" :content="ts('Enter your last name here')['Enter your last name here']" placement="top">
                      <el-input v-model="registerForm.lastName"></el-input>
                      </el-tooltip>
                      </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="80">
                  <el-col :span="12">
                    <div class="password" id="password1">
                      <el-form-item style="margin-bottom: 20px" prop="password" :label="ts('Password:')['Password:']"
                                    :rules="[{ validator: validatePass, trigger: 'blur' }]">
                        <!-- <div class="item-icon">
                          <img src="../assets/images/icon-password2.svg" class="h-5 w-5 object-contain" alt="" />
                        </div>-->
                        <el-tooltip class="box-item" :content="ts('Create a password for your account')['Create a password for your account']" placement="top">
                        <el-input type="password" v-model="registerForm.password"
                                  autocomplete="off"></el-input>
                        </el-tooltip>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="password" id="password2">
                      <el-form-item prop="checkPass" :label="ts('Confirm Password:')['Confirm Password:']"
                                    :rules="[{ validator: validatePass2, trigger: 'blur' }]">
                        <!-- <div class="item-icon">
                          <img src="../assets/images/icon-password1.svg" class="h-5 w-5 object-contain" alt="" />
                        </div> -->
                        <el-tooltip class="box-item" :content="ts('Confirm password')['Confirm password']" placement="top">
                        <el-input type="password" v-model="registerForm.checkPass"
                                   autocomplete="off"></el-input>
                        </el-tooltip>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="80">
                  <el-col :span="12">
                    <!-- <el-form-item :label="ts('Nationality :')['Nationality :']" prop="nationality" class="nationality" :rules="[{ required: true, message: ts('不能为空')['不能为空'] }]">
                  <vue-country-intl type="country" placeholder="" v-model="registerForm.nationality"></vue-country-intl>
                </el-form-item> -->
                    <el-form-item :label="ts('Contact Number :')['Contact Number :']" prop="contactNumber" class="phone"
                                  :rules="[{ required: true, message: ts('不能为空')['不能为空'] }]">
                    <el-tooltip class="box-item" :content="ts('Enter your area code of phone number')['Enter your area code of phone number']" placement="top">
                    <vue-country-intl type="phone" placeholder="" :onlyValue="false" :showLabelImg="true"
                       v-model="registerForm.areaCode"></vue-country-intl>
                    </el-tooltip>
                    <el-tooltip class="box-item" :content="ts('Enter your contact phone number')['Enter your contact phone number']" placement="top">
                    <el-input v-model="registerForm.contactNumber"></el-input>
                    </el-tooltip>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item id="username" :label="ts('Email:')['Email:']" prop="username"
                                  :rules="[{ validator: checkUsername, trigger: 'blur' }]">
                      <!-- <div class="item-icon">
                        <img src="../assets/images/icon-user-black2.svg" class="h-5 w-5 object-contain" alt="" />
                      </div> -->
                      <el-tooltip class="box-item" :content="ts('Enter an email address for your account')['Enter an email address for your account']" placement="top">
                      <el-input v-model="registerForm.username"></el-input>
                      </el-tooltip>
                    </el-form-item>
                  </el-col>
                </el-row>

              </el-form>
            </div>
          </div>
          <div >
            <div v-if="!registerState.loggedin" class="btn btn-theme" style="display:flex;text-align: center;border-radius: 0;justify-content: center" :loading="btnLoading" @click="submitRegisterForm('registerForm')">
              {{ ts('注册和支付')['注册和支付'] }}
            </div>
            <div v-else class="btn btn-theme" style="display:flex;text-align: center;border-radius: 0;justify-content: center" :loading="btnLoading" @click="createOrder">
              {{ ts('Pay Now')['Pay Now'] }}
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- 支付方式 -->
    <el-dialog :visible.sync="payMethodVisible" width="1000px">
      <PayMethod orderType="PRODUCT_ORDER" :orderId="groupId" @confirm="createPayment" v-if="type != 'select'"/>
      <PayMethod orderType="GROUP_ORDER" :orderId="groupId" @confirm="createPayment" v-else/>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { getAction, postAction, uploadAction } from '@/api/manage'
import { LanguagePackage } from '@/mixins/LanguagePackage'
import {ACCESS_TOKEN, USER_INFO} from '@/store/mutation-types'
import PayMethod from '@/components/PayMethod.vue'

export default {
  name: 'ProductOrder',
  props: ['productId', 'type', 'hotelIdDefault', 'currency', 'orderList','productPage'],
  mixins: [LanguagePackage],
  data() {
    return {
      form: {
        quantity: 1,
        note: '',
      },
      registerState:{
        loggedin:false,
      },
      registerForm: {
        firstName: "",
        lastName: "",
        contactNumber: "",
        password: "",
        checkPass: "",
        areaCode: ""
      },
      step:1,
      groupId:'',
      detail: null,
      curDate: new Date(),
      dateArray: [],
      curTime: null,
      productType: null,
      // dateIndex: 0,
      extraFeeList: [],
      payMethodVisible: false,
      hotelList: [],
      btnLoading: false,
      hotelId: null,
      groupOrderId: null,
    }
  },
  components: {
    PayMethod,
  },
  watch: {
    curDate(newVal, oldVal) {
      if (dayjs(newVal).month() != dayjs(oldVal).month()) {
        this.getDateRange(newVal)
      }
    },
  },
  computed: {
    dateIndex() {
      let index = 0
      index = this.findDateIndex(dayjs(this.curDate).format('YYYY-MM-DD'))
      console.log(`dateIndex: ${index}`)
      return index
    },
    curDateAvailability() {
      return this.detail.inventoryAvailability[this.findDateIndex(dayjs(this.curDate).format('YYYY-MM-DD'))]
    },
    timeList() {
      let arr = []
      if (this.detail) {
        arr = this.detail.dateOfSku[this.dateIndex]
      }
      if (this.productType == '1') {
        this.curTime = arr[0]
      }
      return arr
    },
    curDateFormat() {
      return dayjs(this.curDate).format('YYYY-MM-DD')
    },
    totalPrice() {
      let price = 0
      if (this.curTime) {
        price = this.curTime.price * this.form.quantity
      }
      return price
    },
    optionalList() {
      let arr = this.extraFeeList
      arr = arr
        .map((item) => {
          if (item.number > 0) {
            return item
          }
          return null
        })
        .filter((x) => x !== null)
      return arr
    },
    optionCost() {
      let cost = 0
      this.optionalList.forEach((item) => {
        cost += item.amount * item.number
      })
      return cost
    },
    // 税费列表
    taxes() {
      let taxes = this.detail.taxes
      taxes = taxes.map((x) => {
        // taxScope: 1. 只计算价格；2.计算费用和价格；3.只计算费用
        // taxRate:  1 = 0.01
        if (x.taxScope == '1') {
          x.price = (x.taxRate * this.totalPrice) / 100
        } else if (x.taxScope == '2') {
          x.price = (x.taxRate * (this.totalPrice + this.optionCost)) / 100
        } else if (x.taxScope == '3') {
          x.price = (x.taxRate * this.optionCost) / 100
        }
        return x
      })
      return taxes
    },
    totalAmount() {
      let amount = 0
      amount = this.totalPrice + this.optionCost
      this.taxes.forEach((item) => {
        amount += item.price
      })
      return amount
    },
  },
  created() {
    if (this.hotelIdDefault) {
      this.hotelId = this.hotelIdDefault
    }
    this.getDateRange()
    console.log(`type: ${this.type}`)
    // type:select, 酒店预定时选择产品服务，默认当前酒店
    if (this.type != 'select') {
      this.getHotelList()
    }
    const userInfo = this.$ls.get(USER_INFO)
    if (!userInfo) {
      this.registerState.loggedin = false
    } else {
      this.registerState.loggedin = true
    }
  },
  mounted() {},
  methods: {
    checkUsername(rule, value, callback) {
      console.log(rule);
      console.log(value);
      let reg = /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/
      // const usernameTip = tippy(document.getElementById('username'));
      if (!reg.test(value)) {
        callback(new Error(this.translate('Please enter the correct email address')))
        // usernameTip.setContent(this.translate('Please enter the correct email address'))
        // usernameTip.show();
      }

      if (!value) {
        callback(new Error(this.translate('请输入邮箱')))
        // usernameTip.setContent(this.translate('请输入邮箱'))
        // usernameTip.show();
      } else {
        callback()
      }
    },
    validatePass(rule, value, callback) {
      // const password1Tip = tippy(document.getElementById('password1'));
      // alert()
      if (value === '') {
        callback(new Error(this.translate('请输入密码')))
        // password1Tip.setContent(this.translate('请输入密码'))
        // password1Tip.show();
        // callback();
      } else {

        // if (this.form.checkPass !== '') {
        //   this.$refs.form.validateField('checkPass')
        // }
        callback()
      }
    },
    validatePass2(rule, value, callback) {
      // const password2Tip = tippy(document.getElementById('password2'));
      if (value === '') {
        callback(new Error(this.translate('请再次输入密码')))
        // password2Tip.setContent(this.translate('请再次输入密码'))
        // password2Tip.show();
      } else if (value !== this.registerForm.password) {
        callback(new Error(this.translate('两次输入密码不一致!')))
        // password2Tip.setContent(this.translate('两次输入密码不一致'))
        // password2Tip.show();
      } else {
        callback()
      }
    },
    submitRegisterForm(formName) {
      this.$refs[formName].validate((valid) => {
        this.btnLoading = true
        if (valid) {
          let params = { ...this.registerForm }
          delete params.checkPass
          const loading = this.$loading({
            lock: true,
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          })
          // const usernameTip = tippy(document.getElementById('username'));
          getAction(`/pc/home/checkOnlyUser`, {
            username: params.username,
          }).then((res) => {
            console.log(res)
            if (res.success) {
              params.noMessage = true;
              postAction(`/pc/home/pmsRegisterFast`, params).then((res) => {
                console.log(res)
                if (!res.success) {
                  this.$message.error(this.translate(res.message));
                  loading.close()
                } else {
                  this.registerState.registered = true
                  let data = { username: params.username, password: params.password }
                  postAction(`/pc/home/memberLogin`, data).then((res) => {
                    console.log(res)
                    //this.loginBtn = false
                    if (res.code == '200') {
                      this.$ls.set(ACCESS_TOKEN, res.result.token, 7 * 24 * 60 * 60 * 1000)
                      this.$ls.set(USER_INFO, res.result.userInfo, 7 * 24 * 60 * 60 * 1000)
                      this.$store.commit('SET_INFO', res.result.userInfo)
                      this.$store.commit('updateUserIdInProductList', res.result.userInfo.id)
                      this.registerState.loggedin = true
                      postAction(`/pc/home/personalRegistration`, params).then((res) => {
                        console.log(res.message)
                        this.createOrder()
                      })

                      //this.$router.push('/user')
                    }else{
                      this.$message.error(this.translate(res.message));
                      loading.close()
                    }
                  })
                }
                this.btnLoading = false
              })
            } else {

              let data = { username: this.registerForm.username, password: this.registerForm.password }
              postAction(`/pc/home/memberLogin`, data).then((res) => {
                loading.close()
                console.log(res)
                //this.loginBtn = false
                if (res.code == '200') {
                  this.$ls.set(ACCESS_TOKEN, res.result.token, 7 * 24 * 60 * 60 * 1000)
                  this.$ls.set(USER_INFO, res.result.userInfo, 7 * 24 * 60 * 60 * 1000)
                  this.$store.commit('SET_INFO', res.result.userInfo)
                  this.$store.commit('updateUserIdInProductList', res.result.userInfo.id)
                  this.registerState.loggedin = true
                  this.createOrder()
                } else {
                  this.$message.error(this.translate('Username already exists, but password is different.'));
                  // usernameTip.setContent(this.translate('Username already exists, but password is different.'))
                  // usernameTip.show();
                }
              })

            }
          })

        } else {
          console.log('error submit!!')
          this.btnLoading = false
          return false
        }
      })
    },
    // 某天所在周的周一
    weekFirstDay(date) {
      if (new Date(date).getDay() !== 0) {
        const weekfirst = dayjs(date).startOf('week').add(1, 'day')
        return weekfirst
      }
      const weekfirst = dayjs(date).subtract(1, 'day').startOf('week').add(1, 'day')
      return weekfirst
    },
    // 某天所在周的周日
    weekLastDay(date) {
      const weeklast = dayjs(date).endOf('week').add(1, 'day')
      return weeklast
    },
    getDateRange(date) {
      let firstDate = new Date(dayjs().startOf('month')) //当月的第一天
      let lastDate = new Date(dayjs().endOf('month')) // 当月的最后一天
      if (date) {
        firstDate = new Date(dayjs(date).startOf('month')) //当月的第一天
        lastDate = new Date(dayjs(date).endOf('month')) // 当月的最后一天
      }

      let calendarFirstDay = this.weekFirstDay(firstDate)
      let calendarLastDay = this.weekLastDay(lastDate)
      const diffDay = calendarLastDay.diff(calendarFirstDay, 'day') // 差值
      if (diffDay !== 41) {
        // 如果差值不为41天，则向后加7天
        calendarLastDay = dayjs(calendarLastDay).add(7, 'day')
      }
      const st = dayjs(calendarFirstDay).format('YYYY-MM-DD')
      const ed = dayjs(calendarLastDay).format('YYYY-MM-DD')
      this.getData(st, ed)
      this.getDateArray(st, ed)
    },
    // 两个时间范围内的日期数组
    getDateArray(start, end) {
      let arr = []
      let st = start.split('-')
      let et = end.split('-')
      let startTime = new Date(st[0], st[1] - 1, st[2]).getTime()
      let endTime = new Date(et[0], et[1] - 1, et[2]).getTime()

      for (let i = startTime; i <= endTime; ) {
        arr.push(dayjs(i).format('YYYY-MM-DD'))
        i += 24 * 60 * 60 * 1000
      }
      this.dateArray = arr
    },
    findDateIndex(date) {
      let index = 0
      if (this.dateArray) {
        index = this.dateArray.findIndex((item) => item === date)
      }
      return index
    },
    // 产品详情
    getData(st, ed) {
      console.log(st, ed)
      if (st && ed) {
        getAction(`/user/api/productDetail`, {
          productId: this.productId,
          st,
          ed,
        }).then((res) => {
          this.detail = res.result
          const { extraFeeList, taxes } = res.result
          if (extraFeeList && extraFeeList.length > 0) {
            this.extraFeeList = extraFeeList.map((x) => {
              return {
                ...x,
                number: 0,
              }
            })
          }

          this.$emit("ok");
          // productType: 1 商品 2 活动 3 服务
          this.productType = res.result.productType

          this.setCalendarDisabled()
          // console.log(this.$refs)
          // setTimeout(() => {
          //   console.log(this.$refs['calendar'])
          // }, 500)
        })
      }
    },
    getHotelList() {
      getAction(`/user/api/getHotelInfoList`, {
        productId: this.productId,
      }).then((res) => {
        this.hotelList = res.result
      })
    },
    // 选择时间
    selectTime(time) {
      this.curTime = time
    },
    next(){

      if (!this.curDateAvailability) {
        return this.$message.error(this.translate('No time period selected'))
      }
      if (!this.curTime || !this.curTime.availability) {
        return this.$message.error(this.translate('No time period selected'))
      }


      if(this.productPage.productSaleScope){
        if (!this.groupOrderId) {
          return this.$message.error(this.translate('请选择附属的住宿订单'))
        }
      }else{
        if(!this.hotelId){
          return this.$message.error(this.translate('请选择酒店'))
        }
      }

      this.step=2;
    },

    // 创建订单
    createOrder() {

      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      if (!this.curDateAvailability) {
        return this.$message.error(this.translate('No time period selected'))
      }
      if (!this.curTime || !this.curTime.availability) {
        return this.$message.error(this.translate('No time period selected'))
      }


      if(this.productPage.productSaleScope){
        if (!this.groupOrderId) {
          return this.$message.error(this.translate('请选择附属的住宿订单'))
        }
      }else{
        if(!this.hotelId){
          return this.$message.error(this.translate('请选择酒店'))
        }
      }

      this.btnLoading = true
      const userInfo = this.$ls.get(USER_INFO)
      let data = {
        apiOrderModels: [],
        productOrderVoList: [
          {
            feeList: [],
            id: this.productId,
            name: this.detail.name,
            note: this.form.note,
            productDate: this.curDateFormat,
            quantity: this.form.quantity,
            skuId: this.curTime.id,
            skuName: this.curTime.name,
            userId: userInfo.id,
          },
        ],
        userId: userInfo.id,
      }

      if (this.type != 'select' && this.productPage.productSaleScope) {
        // 产品页单独下单
        data.productOrderVoList[0].groupOrderId = this.groupOrderId
      } else {
        // 酒店下单中选择产品
        data.productOrderVoList[0].hotelId = this.hotelId
      }

      if (this.optionalList.length > 0) {
        data.productOrderVoList[0].feeList = this.optionalList.map((x) => {
          return {
            id: x.id,
            quantity: x.number,
          }
        })
      }

      postAction(`/user/api/createOrder`, data).then((res) => {
        console.log(res)
        if (res.success) {
          this.payMethodVisible = true
          this.groupId = res.result
        }
        this.btnLoading = false
        loading.close();
      })
    },

    // 创建订单支付
    createPayment(platForm) {
      if (this.type != 'select') {
        // 产品页单独下单支付
        this.$store.dispatch('createPayment', {
          orderType: 'PRODUCT_ORDER',
          groupId: this.groupId, // 组合订单Id
          platForm, // Stripe , Paypay
        })
      } else {
        this.$store.dispatch('createPayment', {
          groupId: this.groupId, // 组合订单Id
          hotelId: this.hotelId, // 酒店Id
          platForm, // Stripe , Paypay
        })
      }
    },

    // 酒店房间下单里选择相关产品
    confirmOrder() {
      if (!this.curDateAvailability) {
        return this.$message.error(this.translate('No time period selected'))
      }
      if (!this.curTime || !this.curTime.availability) {
        return this.$message.error(this.translate('No time period selected'))
      }
      this.btnLoading = true
      const userInfo = this.$ls.get(USER_INFO)
      let data = {
        hotelId: this.hotelId,
        id: this.productId,
        name: this.detail.name,
        note: this.form.note,
        productDate: this.curDateFormat,
        quantity: this.form.quantity,
        skuId: this.curTime.id,
        skuName: this.curTime.name,
        userId: userInfo?.id,
        price: this.curTime.price,
        amount: this.totalAmount,
      }
      if (this.optionalList.length > 0) {
        data.feeList = this.optionalList.map((x) => {
          return {
            id: x.id,
            quantity: x.number,
          }
        })
      }

      this.$store.commit('pushProductList', data)
      this.$store.commit('setProductChooseShow', false)

      this.btnLoading = false
    },

    // 禁止日历点击
    setCalendarDisabled() {
      this.$nextTick(() => {
        let dom = document.querySelectorAll('.calendar-disabled')
        dom.forEach((item, i) => {
          item.parentNode.parentNode.classList.add('disabled')
        })
      })
    },
  },
}
</script>

<style scoped lang="sass"></style>
